import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidLockAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 9V7c0-2.8-2.2-5-5-5S7 4.2 7 7v2c-1.7 0-3 1.3-3 3v7c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3v-7c0-1.7-1.3-3-3-3ZM9 7c0-1.7 1.3-3 3-3s3 1.3 3 3v2H9V7Zm4 10c0 .6-.4 1-1 1s-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3Z"/>
  </SvgIcon>
}

export default SolidLockAltIcon
